import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getBlockEAdhigamStudentCount, getBlocksMap, getDistrictEAdhigamStudentCount, getDistrictMap, getEAdhigamStudent, getMonitoringStatsData, getOverAllDistrictAndBlockStudentStats, getOverAllDistrictStudentStats, getOverAllEAdhigamTeacherStats, getOverAllStudentStats, getOverAllTeacherStats } from '../../../Services/NewStats/StateOverViewAPIs';
import { IStateMapdata, IOverAllStudent, IEAdhigamData, IOverAllTeacher, IEadhigamTeacher, ITeacherStats, IDistrictMapData } from '../../../types';
import { State } from '../../../Reducers/types';
import { filterSlice } from '../../../Reducers/User/filterSlice';

const DefaultOverViewStudent = {
    Total_Student: 0,
    Total_Usage: 0,
    ActiveStudent: 0,
    Avg_Usage: "",
    Total_Assessments: 0,
    Total_Diagnostic_Tests_Taken: "",
    Total_Remedial: "",
    Total_queries_raised: "",
    Total_queries_solved: "",
    Total_time_tests: "",
    Total_time_videos: "",
    Usage_Before_2: 0,
    Usage_After_2: 0
}

const DefaultOverViewTeacher = {
    App_Usage: '',
    Total_assessments: "",
    Total_teacher: 0,
    Total_tickets_pending: 0,
    Total_tickets_resolved: "",
    Total_Active_Teacher: 0,
    EadhigamTeacher: 0
}

export default function useOverViewStudent() {

    const { filter } = useSelector((state: State) => state);
    const dispatch = useDispatch();

    const [averageCriteria, setAverageCriteria] = useState<"total" | "active">("total");
    const [isOverAllStudentLoading, setIsOverAllStudentLoading] = useState<boolean>(false)
    const [isOverAllTeacherLoading, setIsOverAllTeacherLoading] = useState<boolean>(false)
    const [isAdhigamStudentLoading, setIsAdhigamStudentLoading] = useState<boolean>(false)
    const [isMapLoading, setIsMapLoading] = useState<boolean>(false)
    const [isFirstLoading, setIsFirstLoading] = useState<boolean>(true)

    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedBlock, setSelectedBlock] = useState("");
    const [stateMapData, setStateMapData] = useState<IStateMapdata[]>()
    const [districtMapData, setDistrictMapData] = useState<IDistrictMapData>([])
    const [e_AdhigamStudentData, setE_AdhigamStudentData] = useState<IEAdhigamData>({ total_adhigam_students: 0, Avg_Adhigam_students: 0 })
    const [district_E_AdhigamStudentData, setDistrict_E_AdhigamStudentData] = useState<IEAdhigamData>()
    const [block_E_AdhigamStudentData, setBlock_E_AdhigamStudentData] = useState<IEAdhigamData>()

    const [OverAllStudent, setOverAllStudent] = useState<IOverAllStudent>(DefaultOverViewStudent)
    const [OverAllDistrictStudent, setOverAllDistrictStudent] = useState<IOverAllStudent>(DefaultOverViewStudent)
    const [OverAllBlockStudent, setOverAllBlockStudent] = useState<IOverAllStudent>(DefaultOverViewStudent)
    const [OverAllTeacher, setOverAllTeacher] = useState<IOverAllTeacher>(DefaultOverViewTeacher)
    const [OverAllDistrictTeacher, setOverAllDistrictTeacher] = useState<IOverAllTeacher>(DefaultOverViewTeacher)
    const [OverAllBlockTeacher, setOverAllBlockTeacher] = useState<IOverAllTeacher>(DefaultOverViewTeacher)

    const [selectedWeekNo,setSelectedWeekNo]=useState<number>(6);

    useEffect(() => {
        getStudentOverview();
        getDistrictMapData();
        getE_AdhigamStudent();
        getTeacherOverview();
        getTeacherEAdhigamOverview()
        getTeacherMonitoringOverview()
    }, [selectedWeekNo, filter.year])


    // useEffect(() => {
    //     if(isFirstLoading){
    //         setIsFirstLoading(false)
    //     }
    //     else{
    //     getStudentOverview();
    //     getDistrictMapData();
    //     getE_AdhigamStudent();
    //     getTeacherOverview();
    //     getTeacherEAdhigamOverview()
    //     if(selectedDistrict != "" && selectedBlock ==""){
    //         getStudentDistrictOverView(selectedDistrict)
    //         getDistrictEAdhigamStudent(selectedDistrict)
    //     }
    //     if(selectedDistrict !=""&& selectedBlock !=""){
    //         getOverAllDistrictAndBlockStatsData(selectedDistrict, selectedBlock)
    //         getBlockEAdhigamStudent(selectedDistrict, selectedBlock)
    //     }
    // }
    // }, [selectedWeekNo])

    useEffect(() => {
        if (selectedDistrict !== "") {
            getStudentDistrictOverView(selectedDistrict)
            getDistrictEAdhigamStudent(selectedDistrict)
            getTeacherOverview()
            getTeacherEAdhigamOverview()
            getBlocksMapEAdhigamData()
            getTeacherMonitoringOverview()
        } else {
            getStudentOverview();
            getDistrictMapData();
            getE_AdhigamStudent();
            getTeacherOverview();
            getTeacherEAdhigamOverview()
            getTeacherMonitoringOverview()
        };
    }, [selectedDistrict])

    useEffect(() => {
        if (selectedDistrict !== "" && selectedBlock !== "") {
            getOverAllDistrictAndBlockStatsData(selectedDistrict, selectedBlock)
            getBlockEAdhigamStudent(selectedDistrict, selectedBlock)
            getTeacherOverview()
            getTeacherEAdhigamOverview()
            getTeacherMonitoringOverview()
        };
        if (selectedDistrict !== "" && selectedBlock == "") {
            getStudentDistrictOverView(selectedDistrict)
            getDistrictEAdhigamStudent(selectedDistrict)
            getTeacherOverview()
            getTeacherEAdhigamOverview()
            getBlocksMapEAdhigamData()
            getTeacherMonitoringOverview()
        };
    }, [selectedBlock])

    // static data function 
    //   useEffect(()=>{
    //     const timeoutId = setTimeout(()=>{
    //         setOverAllStudent({
    //             Total_Student:513836,
    //             Total_Usage: 5144564,
    //             Avg_Usage: "51.4822",
    //             Total_Assessments: 249752,
    //             Total_Diagnostic_Tests_Taken: "",
    //             Total_Remedial: "365406",
    //             Total_queries_raised: "13735",
    //             Total_queries_solved: "26",
    //             Total_time_tests: "152201903",
    //             Total_time_videos: "667901",
    //             Usage_Before_2: 0,
    //             Usage_After_2: 0,
    //             ActiveStudent:67010,
    //         })   
    //         setOverAllTeacher((prev)=>({...prev,Total_tickets_pending:(13735-26)}))
    //         setIsOverAllStudentLoading(false)

    //         return () => {
    //             clearTimeout(timeoutId);
    //           };

    //     },8000)
    // },[])


    //  HANDLER FUNCTIONS
    const updateYearSelection = (year: number) => {
        dispatch(filterSlice.actions.updateYear(year));
    };


    const getDistrictMapData = async () => {
        try {
            setIsMapLoading(true)
            const res = await getDistrictMap(selectedWeekNo, filter.year);
            if (res?.data?.Is_Success) {
                setStateMapData(res?.data?.response)
            }
        }
        catch (error) {
            console.log("error while getting state map data")
            setStateMapData([])
        }
        setIsMapLoading(false)
    }


    const getBlocksMapEAdhigamData = async () => {
        try {
            setIsMapLoading(true)
            const res = await getBlocksMap(selectedDistrict, selectedWeekNo, filter.year);
            if (res?.data?.Is_Success) {
                setDistrictMapData(res?.data?.response)
            }
        }
        catch (error) {
            console.log("error while getting district map data")
            setDistrictMapData([])
        }
        setIsMapLoading(false)
    }


    // Students Data API
    const getStudentOverview = async () => {
        try {
            setIsOverAllStudentLoading(true);
            const res = await getOverAllStudentStats(selectedWeekNo, filter.year);
            if (res?.data?.Is_Success) {
                setOverAllStudent({ ...res?.data?.response[0], ActiveStudent: res?.data?.response[1] ? res?.data?.response[1]?.Total_Active_Student : 0 })
                let pendingQuires = +res?.data?.response[0]?.Total_queries_raised - Number(res?.data?.response[0]?.Total_queries_solved)
                setOverAllTeacher((prev) => ({ ...prev, Total_tickets_resolved: res?.data?.response[0]?.Total_queries_solved, Total_tickets_pending: pendingQuires }))
            }

        } catch (error) {
            console.log("error getting student overview");
            setOverAllStudent(DefaultOverViewStudent)
            setOverAllTeacher((prev) => ({ ...prev, Total_tickets_resolved: "0", Total_tickets_pending: 0 }))
        }
        setIsOverAllStudentLoading(false);
    };

    const getStudentDistrictOverView = async (dist: string) => {
        try {
            setIsOverAllStudentLoading(true);
            const res = await getOverAllDistrictStudentStats(dist, selectedWeekNo, filter.year)
            if (res?.data?.Is_Success) {
                setOverAllDistrictStudent({ ...res?.data?.response[0], ActiveStudent: res?.data?.response[1]?.Total_Active_Student })
                let pendingQuires = Number(res?.data?.response[0]?.Total_queries_raised) - Number(res?.data?.response[0]?.Total_queries_solved)
                setOverAllDistrictTeacher((prev) => ({ ...prev, Total_tickets_resolved: res?.data?.response[0]?.Total_queries_solved, Total_tickets_pending: pendingQuires }))
            }
        } catch (error) {
            setOverAllDistrictStudent(DefaultOverViewStudent)
            setOverAllDistrictTeacher((prev) => ({ ...prev, Total_tickets_resolved: "0", Total_tickets_pending: 0 }))
            console.log("error while getting District Over View data")
        }
        setIsOverAllStudentLoading(false);
    }

    const getOverAllDistrictAndBlockStatsData = async (dist: string, block: string) => {
        try {
            setIsOverAllStudentLoading(true);
            const res = await getOverAllDistrictAndBlockStudentStats(dist, block, selectedWeekNo, filter.year);
            if (res?.data?.Is_Success) {
                setOverAllBlockStudent({ ...res?.data?.response[0], ActiveStudent: res?.data?.response[1]?.Total_Active_Student })
                let pendingQuires = Number(res?.data?.response[0]?.Total_queries_raised) - Number(res?.data?.response[0]?.Total_queries_solved)
                setOverAllBlockTeacher((prev) => ({ ...prev, Total_tickets_resolved: res?.data?.response[0]?.Total_queries_solved, Total_tickets_pending: pendingQuires }))
            }
        } catch (error) {
            console.log("error while getting Block Stats Data")
            setOverAllBlockStudent(DefaultOverViewStudent)
            setOverAllBlockTeacher((prev) => ({ ...prev, Total_tickets_resolved: "0", Total_tickets_pending: 0 }))
        }
        setIsOverAllStudentLoading(false);
    }


    // e-Adhigam Count API
    const getE_AdhigamStudent = async () => {
        try {
            setIsAdhigamStudentLoading(true)
            const res = await getEAdhigamStudent(selectedWeekNo, filter.year);
            if (res?.data?.Is_Success) {
                setE_AdhigamStudentData(res?.data?.response)
            }

        } catch (error) {
            setE_AdhigamStudentData({ total_adhigam_students: 0, Avg_Adhigam_students: 0 })
            console.log("error whilw fetch EaDigam student count")
        }
        setIsAdhigamStudentLoading(false)
    }

    const getDistrictEAdhigamStudent = async (dist: string) => {
        try {
            setIsAdhigamStudentLoading(true)
            const res = await getDistrictEAdhigamStudentCount(dist, selectedWeekNo, filter.year)
            if (res?.data?.Is_Success) {
                setDistrict_E_AdhigamStudentData(res?.data?.response)
            }

        } catch (error) {
            setDistrict_E_AdhigamStudentData({ total_adhigam_students: 0, Avg_Adhigam_students: 0 })
            console.log("error whilw fetch EaDigam student count")
        }
        setIsAdhigamStudentLoading(false)
    }

    const getBlockEAdhigamStudent = async (dist: string, block: string) => {
        try {
            setIsAdhigamStudentLoading(true)
            const res = await getBlockEAdhigamStudentCount(dist, block, selectedWeekNo, filter.year)
            if (res?.data?.Is_Success) {
                setBlock_E_AdhigamStudentData(res?.data?.response)
            }

        } catch (error) {
            setBlock_E_AdhigamStudentData({ total_adhigam_students: 0, Avg_Adhigam_students: 0 })
            console.log("error while fetch Eadhigam student count")
        }
        setIsAdhigamStudentLoading(false)
    }

    //TEACHER STATS 
    const getTeacherOverview = async () => {
        try {
            setIsOverAllTeacherLoading(true);
            if (!!selectedDistrict && !selectedBlock) {
                const res = await getOverAllTeacherStats(selectedDistrict, selectedBlock, selectedWeekNo, filter.year);
                if (res?.data?.Is_Success) {
                    let data: ITeacherStats = res?.data?.response
                    setOverAllDistrictTeacher((prev) => ({
                        ...prev,
                        Total_teacher: data?.Total_teacher,
                        App_Usage: data?.App_Usage,
                        Total_assessments: data?.Total_assessments,
                        Total_Active_Teacher: data?.Total_Active_Teacher,
                    }))
                }
                else {
                    setOverAllDistrictTeacher(DefaultOverViewTeacher)
                }
            }
            else if (!!selectedDistrict && !!selectedBlock) {

                const res = await getOverAllTeacherStats(selectedDistrict, selectedBlock, selectedWeekNo, filter.year);
                if (res?.data?.Is_Success) {
                    let data: ITeacherStats = res?.data?.response
                    setOverAllBlockTeacher((prev) => ({
                        ...prev,
                        Total_teacher: data?.Total_teacher,
                        App_Usage: data?.App_Usage,
                        Total_assessments: data?.Total_assessments,
                        Total_Active_Teacher: data?.Total_Active_Teacher,
                        //    Total_tickets_pending: data?.Total_tickets_pending, 
                        //    Total_tickets_resolved: data?.Total_tickets_resolved
                    }))
                }
                else {
                    setOverAllBlockTeacher(DefaultOverViewTeacher)
                }
            }
            else {

                const res = await getOverAllTeacherStats(selectedDistrict, selectedBlock, selectedWeekNo, filter.year);
                if (res?.data?.Is_Success) {
                    let data: ITeacherStats = res?.data?.response
                    setOverAllTeacher((prev) => ({
                        ...prev,
                        Total_teacher: data?.Total_teacher,
                        App_Usage: data?.App_Usage,
                        Total_assessments: data?.Total_assessments,
                        Total_Active_Teacher: data?.Total_Active_Teacher,
                        // Total_tickets_pending: data?.Total_tickets_pending,
                        // Total_tickets_resolved: OverAllStudent?.Total_queries_solved
                    }));
                }
                else {
                    setOverAllTeacher(DefaultOverViewTeacher)
                }
            }
        } catch (error) {
            console.log("error getting student overview");
        }
        setIsOverAllTeacherLoading(false);
    };

    const getTeacherMonitoringOverview = async () => {
        // try {
        //     if (!!selectedDistrict && !selectedBlock) {
        //         const resp = await getMonitoringStatsData(selectedDistrict, "-1", selectedWeekNo)
        //         if (resp?.data?.Is_Success) {
        //             setOverAllDistrictTeacher((prev) => ({ ...prev, studentMonitoring: resp?.data?.response?.total_time_in_min }))
        //         }
        //     }
        //     else if (!!selectedDistrict && !!selectedBlock) {

        //         const resp = await getMonitoringStatsData(selectedDistrict,selectedBlock, selectedWeekNo)
        //         if (resp?.data?.Is_Success) {
        //             setOverAllBlockTeacher((prev) => ({ ...prev, studentMonitoring: resp?.data?.response?.total_time_in_min }))
        //         }
        //     }
        //     else {
        //         const resp = await getMonitoringStatsData("-1", "-1", selectedWeekNo)
        //         if (resp?.data?.Is_Success) {
        //             setOverAllDistrictTeacher((prev) => ({ ...prev, studentMonitoring: resp?.data?.response?.total_time_in_min }))
        //         }
        //     }
        // } catch (error) {
        //     console.log("error getting student overview");
        //     setOverAllTeacher((prev)=>({...prev ,studentMonitoring : 0 }))
        // }
        // setIsOverAllTeacherLoading(false);
    };

    const getTeacherEAdhigamOverview = async () => {
        try {
            setIsOverAllTeacherLoading(true);
            if (!!selectedDistrict && !selectedBlock) {
                const response = await getOverAllEAdhigamTeacherStats(selectedDistrict, selectedBlock, selectedWeekNo, filter.year);
                if (response?.data?.Is_Success) {
                    const adhigamData: IEadhigamTeacher = response?.data?.response
                    setOverAllDistrictTeacher((prev) => ({ ...prev, EadhigamTeacher: adhigamData?.total_teacher_eadhigam ? adhigamData?.total_teacher_eadhigam : 0 }))
                }
            }
            else if (!!selectedDistrict && !!selectedBlock) {
                const response = await getOverAllEAdhigamTeacherStats(selectedDistrict, selectedBlock, selectedWeekNo, filter.year);
                if (response?.data?.Is_Success) {
                    const adhigamData: IEadhigamTeacher = response?.data?.response
                    setOverAllBlockTeacher((prev) => ({ ...prev, EadhigamTeacher: adhigamData?.total_teacher_eadhigam ? adhigamData?.total_teacher_eadhigam : 0 }))
                }
            }
            else {
                const response = await getOverAllEAdhigamTeacherStats(selectedDistrict, selectedBlock, selectedWeekNo, filter.year);
                if (response?.data?.Is_Success) {
                    const adhigamData: IEadhigamTeacher = response?.data?.response
                    setOverAllTeacher((prev) => ({ ...prev, EadhigamTeacher: adhigamData?.total_teacher_eadhigam ? adhigamData?.total_teacher_eadhigam : 0 }))
                }
            }
        } catch (error) {
            setOverAllDistrictTeacher((prev) => ({ ...prev, EadhigamTeacher: 0 }))
            setOverAllBlockTeacher((prev) => ({ ...prev, EadhigamTeacher: 0 }))
            setOverAllTeacher((prev) => ({ ...prev, EadhigamTeacher: 0 }))
            console.log("error getting student overview")
        }
        setIsOverAllTeacherLoading(false);
    };

    return (
        {
            averageCriteria,
            setAverageCriteria,
            getDistrictMapData,
            getE_AdhigamStudent,
            isAdhigamStudentLoading,
            e_AdhigamStudentData,
            district_E_AdhigamStudentData,
            block_E_AdhigamStudentData,
            stateMapData,
            districtMapData,
            isMapLoading,
            isOverAllStudentLoading,
            OverAllStudent,
            OverAllDistrictStudent,
            OverAllBlockStudent,
            getStudentOverview,
            selectedDistrict,
            setSelectedDistrict,
            selectedBlock,
            setSelectedBlock,
            isOverAllTeacherLoading,
            getTeacherOverview,
            OverAllTeacher,
            OverAllDistrictTeacher,
            OverAllBlockTeacher,
            selectedWeekNo,
            setSelectedWeekNo,
            filter,
            updateYearSelection
        }
    );
}
